import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';


class addFavoriteRequest extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'add to favorites request';
        this.Config   = new AppConfig();
        this.payload  = null;
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.payload  = payload;
        this.call(this.Config.api.requests.addFavoriteBenefit, payload);
    }

    //Parse successful response
    onSuccess() {
        let data = this.response.data;
        this.updateState(data);
    }

    //Dispatch actions to update redux state
    updateState() {
        this.dispatch(Actions.updateAddFavorite(this.payload));
    }
}


export default addFavoriteRequest;
